import { Controller } from "@hotwired/stimulus"
import { FacebookEvents } from 'capacitor-facebook-events';

// Connects to data-controller="facebook"
export default class extends Controller {
  async connect() {
    await FacebookEvents.setAdvertiserTrackingEnabled({ enabled: true });
  }
}
